import React from "react"
import { ContentHomePageHeading } from "./Content/ContentHomePageHeading"
import { ContentHomePageCategories } from "./Content/ContentHomePageCategories"
import { ContentProjectsPageProjects } from "./Content/ContentProjectsPageProjects"
import { translation } from "../../helper/translation"

export const PartialProjectsPage = () => {
    return(
        <React.Fragment>
            <ContentHomePageHeading breadcrumb={translation("projects")}/>
            <ContentHomePageCategories />
            <ContentProjectsPageProjects />
        </React.Fragment>
    )
}